import React from 'react';
import Ventas from '../containers/Ventas/Ventas';

const VentasSiempre = () => <Ventas desdeSiempre={true} />;

export default VentasSiempre;
